import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { Bijlage } from '../types/Bijlage'
import type { BijlagenForEntity } from '../types/BijlagenForEntity'

export { fetchBijlagenForEntity, initialState }

const initialState: BijlagenForEntity = {
  data: [],
}

const fetchBijlagenForEntity = async ({
  id,
  type,
}: Entity): Promise<Bijlage[]> => {
  const { data } = await apiClient({
    url: `/rest/${type}/${id}/bijlage`,
    method: 'GET',
  })
  return data
}
